import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addBulkSetup, addShipment, editBulkSetup, getBulkSetupsList } from "api/bulkSetup.api";
import { IShipmentAddFormValues } from "domain/BulkOrders";
import { BulkSetupState, IBulkSetupTemplate, IBulkSetupTemplatesResponse } from "domain/BulkSetup";

const initialState: BulkSetupState = {
  bulk_setups_list: null,
  bulk_setups_list_loaded: false,
  routes: null,
  workScheduleClientSites: [],
  routeData: [],
  selectedDate: new Date().toISOString(),
  selectedMomentDate: new Date().toISOString(),
  workScheduleSitesContainer: {
    data: null,
    date: null,
  },
  workScheduleCardPosition: {
    cardWidth: '',
    cardHeight: '',
  },
  workScheduleSitesOpen: false,
  workScheduleSitesExpand: false,
};

export const doGetBulkSetupsList = createAsyncThunk(
  "BulkSetups",
  async (client_id: number) => {
    const res = await getBulkSetupsList(client_id);
    return res;
  }
);

export const doAddShipment = createAsyncThunk(
  "BulkOrders/AddShipmentRecurrentBulkOrders",
  async (payload: IShipmentAddFormValues) =>
    addShipment(payload).then((res) => {
      return res;
    })
);

export const doAddBulkSetup = createAsyncThunk(
  "BulkSetups",
  async (payload: IBulkSetupTemplate, { dispatch }) =>
    addBulkSetup(payload).then((res) => {
      dispatch(doGetBulkSetupsList(payload?.client_id));
      return res;
    })
);

export const doUpdateBulkSetup = createAsyncThunk(
  "BulkSetups",
  async (payload: IBulkSetupTemplate, { dispatch }) =>
    editBulkSetup(payload.id, payload).then((res: IBulkSetupTemplatesResponse) => {
      dispatch(doGetBulkSetupsList(payload?.client_id));
      return res;
    })
);

const bulkSetupsSlice = createSlice({
  name: "bulkSetups",
  initialState,
  reducers: {
    clearBulkSetups: (state) => {
      state.bulk_setups_list = [];
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    setSelectedMomentDate: (state, action) => {
      state.selectedMomentDate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(doGetBulkSetupsList.fulfilled, (state, action) => {
      state.bulk_setups_list_loaded = true;
      state.bulk_setups_list = action.payload;
    });
  },
});

export const { clearBulkSetups, setSelectedDate, setSelectedMomentDate } = bulkSetupsSlice.actions;

export default bulkSetupsSlice.reducer;
